import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { auth } from "../../utils/auth";
import { withRequest } from "../../utils/request";
import { apiUrl } from "../../utils/apiUrl";
import Form from "./Form";
import Loader from "../general/Loader";
import { getLink, toast } from "../../utils/helpers";

class Edit extends Component {
    state = {
        errors: {},
        tipos: [],
        saving: false,
    };
    componentDidMount() {
        this.getTipos();
    }
    updateEmpleado = async (event) => {
        event.preventDefault();

        this.setState({ saving: true });

        const token = auth.getToken();
        const data = new FormData(event.target);

        const id = this.props.empleado.id;
        const url = "empleados/" + id;

        const res = await fetch(apiUrl(url), {
            method: "post",
            body: data,
            headers: {
                Accept: "application/json",
                "X-Request-With": "XMLHttpRequest",
                Authorization: "Bearer " + token,
            },
        });

        const response = await res.json();

        if (response.code === 422) {
            this.setState({ errors: response.data.message, saving: false });
            toast("Empleado no pudo ser actualizado.", "error");
            return;
        }

        if (response.success) {
            this.props.history.push(getLink("/empleados"));
            toast("Empleado actualizado correctamente.");
        } else {
            toast("Empleado no pudo ser actualizado.", "error");
        }

        this.setState({ saving: false });
    };
    getTipos = async (url = null) => {
        url = url ? url : "tipos";
        const tipos = await this.props.request(url);

        if (tipos.data) {
            this.setState({
                tipos: tipos.data,
            });
        }
    };
    deleteEmpleado = async (event, empleado) => {
        event.preventDefault();

        const token = auth.getToken();

        const url = `empleados/${empleado}`;

        const res = await fetch(apiUrl(url), {
            method: "delete",
            headers: {
                Accept: "application/json",
                "X-Request-With": "XMLHttpRequest",
                Authorization: "Bearer " + token,
            },
        });

        const response = await res.json();

        if (response.success) {
            this.props.history.push(getLink("/empleados"));
            toast("Empleado borrado.");
        } else {
            toast("Empleado no pudo ser borrado.", "error");
        }
    };
    render() {
        const { empleado } = this.props;
        const { errors, tipos, saving } = this.state;

        return (
            <form
                method='post'
                onSubmit={this.updateEmpleado}
                encType='multipart/form-data'>
                <input type='hidden' name='_method' value='patch' />
                <Form empleado={empleado} errors={errors} tipos={tipos} />
                <div className='page-footer text-right'>
                    <button
                        type='button'
                        className='btn float-left'
                        onClick={(e) => this.deleteEmpleado(e, empleado.id)}>
                        <i className='fas fa-trash-alt'></i>
                    </button>
                    <Link to={getLink("/empleados")} className='btn btn-plain'>
                        Cancelar
                    </Link>
                    {saving ? (
                        <Loader type='small' />
                    ) : (
                        <button type='submit' className='btn btn-primary'>
                            Guardar
                        </button>
                    )}
                </div>
            </form>
        );
    }
}

export default withRouter(withRequest(Edit));
